import { FormikProps } from "formik";
import { IAttachmentFile } from "..";
import { ISendEmailDataModel } from "../../../EmailWizard/models/SendEmail";
import { ExecuteModel } from "../../../Steps/ExecuteModel";
import { ITemplateDataModel } from "../../../TemplateWizard/models/Template";

export * from "./AttachmentList";

export interface IAttachmentListWrapperStyleProps {
    Visible: boolean;
    ShouldAnimate: boolean;
}

export interface IAttachmentListProps {
    Attachments: IAttachmentFile[];
    OnAddAttachment: () => void;
    OnRemoveAttachment: (file: IAttachmentFile) => void;
    Visible: boolean;
    FormikProps?: FormikProps<ExecuteModel<ITemplateDataModel | ISendEmailDataModel>>;
}
